import { InjectionToken } from '@angular/core';
export var CONFIGURE_SETTINGS_STORE = new InjectionToken('CONFIGURE_SETTINGS_STORE');
